import React, { useEffect, useState } from 'react'
import { Button, Form, Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { getOneUser, updateUser } from '../Redux/Actions/AuthActions';
import axios from 'axios';
import './UpdateUser.css';
import './NavAuth.css'; // For global variables

const UpdateUser = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  // State for form
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [matricule, setMatricule] = useState('');
  const [localisation, setLocalisation] = useState('');
  const [salaire, setSalaire] = useState('');
  const [phone, setPhone] = useState('');
  const [adress, setAdress] = useState('');
  const [cin, setCin] = useState('')
  const [dateembauche, setDateembauche] = useState('')
  const [fonction, setFonction] = useState('')
  const [cnss, setCnss] = useState('')
  const [role, setRole] = useState("");

  // External data
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  const upUser = useSelector(state => state.AuthReducer.upUser)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await dispatch(getOneUser(id));
        const locRes = await axios.get('/api/Locations/getAllLocations');
        setLocations(locRes.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, dispatch]);

  useEffect(() => {
    if (upUser) {
      setName(upUser.name || '');
      setEmail(upUser.email || '');
      setMatricule(upUser.matricule || '');
      setLocalisation(upUser.localisation?._id || upUser.localisation || '');
      setSalaire(upUser.salaire || '');
      setPhone(upUser.phone || '');
      setAdress(upUser.adress || '')
      setCin(upUser.cin || '')
      setDateembauche(upUser.dateembauche || '')
      setFonction(upUser.fonction || '')
      setCnss(upUser.cnss || '');
      setRole(upUser.role || "");
    }
  }, [upUser]);

  const handleUpdate = (e) => {
    e.preventDefault()
    dispatch(updateUser(id, {
      name, email, matricule, localisation, salaire, phone,
      adress, cin, dateembauche, fonction, cnss, role
    }, navigate));
  }

  if (loading) {
    return (
      <div className="update-page-container align-items-center">
        <Spinner animation="alternate" variant="primary" />
      </div>
    );
  }

  return (
    <div className="update-page-container">
      <div className="update-form-card">
        <div className="update-header">
          <h2 className="update-title">Modifier Collaborateur</h2>
          <p className="update-subtitle">Mise à jour des informations de {upUser?.name || 'l\'utilisateur'}</p>
        </div>

        <Form onSubmit={handleUpdate}>
          {/* SECTION 1: IDENTITÉ */}
          <div className="form-section-title">
            <span>👤</span> Informations Personnelles
          </div>

          <Row>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Nom Complet</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Ex: Jean Dupont"
                  value={name}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Matricule</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setMatricule(e.target.value)}
                  type="text"
                  placeholder="ID Unique"
                  value={matricule}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Adresse Email</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  placeholder="email@exemple.com"
                  value={email}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Numéro CIN</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setCin(e.target.value)}
                  type="text"
                  placeholder="Numéro de carte d'identité"
                  value={cin}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* SECTION 2: PROFESSIONNEL */}
          <div className="form-section-title mt-4">
            <span>💼</span> Informations Professionnelles
          </div>

          <Row>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Rôle & Permissions</Form.Label>
                <Form.Select
                  className="control-premium select-premium"
                  onChange={(e) => setRole(e.target.value)}
                  value={role}
                  required
                >
                  <option value="">Sélectionner un rôle</option>
                  <option value="admin">Direction (Admin Global)</option>
                  <option value="useradmin">Administration (Local)</option>
                  <option value="usertwinpark">Staff Twinpark</option>
                  <option value="userbagngo">Staff Bag N Go</option>
                  <option value="userespace">Staff E-Space</option>
                  <option value="user">Utilisateur standard</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Localisation</Form.Label>
                <Form.Select
                  className="control-premium select-premium"
                  onChange={(e) => setLocalisation(e.target.value)}
                  value={localisation}
                >
                  <option value="">-- Sélectionner l'entité --</option>
                  {locations.map((loc) => (
                    <option key={loc._id} value={loc._id}>{loc.name}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Fonction</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setFonction(e.target.value)}
                  type="text"
                  placeholder="Poste occupé"
                  value={fonction}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">N° Affiliation CNSS</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setCnss(e.target.value)}
                  type="text"
                  placeholder="Affiliation sociale"
                  value={cnss}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Salaire Mensuel</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setSalaire(e.target.value)}
                  type="number"
                  placeholder="Montant en DT"
                  value={salaire}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Date d'embauche</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setDateembauche(e.target.value)}
                  type="date"
                  value={dateembauche}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* SECTION 3: CONTACT */}
          <div className="form-section-title mt-4">
            <span>📱</span> Contact & Coordonnées
          </div>

          <Row>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Téléphone</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setPhone(e.target.value)}
                  type="tel"
                  placeholder="00 000 000"
                  value={phone}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="input-group-premium">
                <Form.Label className="label-premium">Adresse de Résidence</Form.Label>
                <Form.Control
                  className="control-premium"
                  onChange={(e) => setAdress(e.target.value)}
                  type="text"
                  placeholder="Rue, Ville, Code Postal"
                  value={adress}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="button-grid">
            <Button
              variant="light"
              className="btn-update btn-cancel"
              onClick={() => navigate('/AllUser')}
            >
              Annuler
            </Button>
            <Button
              variant="primary"
              type="submit"
              className="btn-update btn-save"
            >
              Enregistrer les modifications
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default UpdateUser;
